<template>
  <nw-form
    :nw-form-value="form"
    @nw-form-input="handleNwFormInput"
    ref="nwForm"
  >
    <b-form-group
      id="Dietary"
      :label="$t('kiosk.dietary')"
      label-for="Dietary"
      label-cols="3"
    >
      <validation-provider
        :name="$t('kiosk.dietary')"
        rules="required"
        #default="{ errors }"
      >
        <v-select
          :value="form.Dietary"
          @input="v => { form.Dietary = v; emitFormData() }"
          label="statusDesc"
          :options="selectOptions.dietary"
          :reduce="option => option.statusCode"
          :searchable="false"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </nw-form>
</template>

<script>
import nwFormTaskTypeMixin from "@/views/kiosk/components/kskNursingWork/mixins/nwFormTaskTypeMixin";
import vSelect from 'vue-select'

export default {
  name: "NwFormDietary",
  mixins: [nwFormTaskTypeMixin],
  components: {vSelect},
}
</script>

<style scoped>

</style>